import Column from "./default"
import {
	addCopyAndPasteEventToElement
} from "./utils"

export default class ButtonColumn extends Column {
	get cursor () {
		return "default"
	}

	constructor ({ options }) {
		super({ options })
	}

	onCellEdit (ctx, setValue, notifyCellEditEnd) {
		const clickTarget = document.createElement("div")
		clickTarget.setAttribute("tabindex", 0)
		clickTarget.style.position = "absolute"
		clickTarget.style.top = "0px"
		clickTarget.style.left = "0px"
		clickTarget.style.bottom = "0px"
		clickTarget.style.right = "0px"
		clickTarget.style.outline = "none"
		clickTarget.addEventListener("keydown", e => {
			if (Column.INPUT_END_KEYS.includes(e.key)) {
				this.onCellEditEnd(ctx)
			}
			if (e.key === "Backspace") {
				setValue(null)
			}
		})
		addCopyAndPasteEventToElement(clickTarget)

		clickTarget.appendChild(this.createButton(ctx, setValue))

		ctx.inputEl.appendChild(clickTarget)
		setTimeout(() => {
			clickTarget.focus()
		})
	}

	createButton (ctx, setValue) {
		const value = ctx.currentCellInfo.value
		const rowId = ctx.currentCellInfo.rowId
		const rowIndex = ctx.currentCellInfo.rowIndex
		const btn = document.createElement("button")
		btn.classList.add("is-cellbtn")
		btn.textContent = "..."
		btn.addEventListener("click", e => {
			if (this.options.onClick) {
				this.options.onClick(value, setValue, { rowId, rowIndex })
			}
		})
		return btn
	}
}
